export default "__VITE_ASSET__BuUjMmlM__"